export default __webpack_public_path__ + "6bde053b99a249ff712d3fef15d00128.png";